const normalizeBirthDateValue = (value) => {
    if (!value) return undefined;

    if (value instanceof Date && !Number.isNaN(value.getTime())) {
        return value.toISOString().slice(0, 10);
    }

    if (typeof value === 'string') {
        if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
        if (value.includes('T')) return value.split('T')[0];
    }

    return undefined;
};

export const ensureAccessUserEditValues = (data = {}) => {
    const safeData = JSON.parse(JSON.stringify(data || {}));

    const arrayFields = [
        ['savings', 'savings'],
        ['valuables', 'valuables'],
        ['debts', 'debts'],
        ['properties', 'properties'],
        ['pension', 'extraPensions', 'extraPensions'],
    ];

    arrayFields.forEach((path) => {
        let obj = safeData;
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < path.length - 1; i++) {
            if (!obj[path[i]]) obj[path[i]] = {};
            obj = obj[path[i]];
        }
        const last = path[path.length - 1];
        if (!Array.isArray(obj[last])) obj[last] = [];
    });

    if (!safeData.basic) safeData.basic = {};
    if (!safeData.household) safeData.household = {};
    if (!safeData.household.partner) safeData.household.partner = {};
    if (!safeData.household.partner.name) safeData.household.partner.name = {};
    if (!Array.isArray(safeData.household.children)) safeData.household.children = [];

    const birthDate = normalizeBirthDateValue(
        safeData.basic.birthDate
        || safeData.basic.birthday
        || safeData.pension?.analysis?.keyFigures?.birthDay,
    );

    if (birthDate) safeData.basic.birthDate = birthDate;

    return safeData;
};
